const appTitle = "Note for the Day";
const version = 0.1;


export { appTitle, version };



// WEBPACK FOOTER //
// ./src/conf.js